import qs from 'qs';
import isEmpty from 'lodash/isEmpty';

export const PROCESS_ORDER_ITEMS = 'PROCESS_ORDER_ITEMS';
export const RECEIVE_LABELS = 'RECEIVE_LABELS';

export const generateLabelUrl = ({ retailerName, label }) => {
  const urlBase = `/returns/${retailerName}/viewlabel?`;
  const params = qs.stringify({ return_id: label.encrypted_return_id });

  return `${urlBase}${params}`;
};

export const labelItemsWithQuantities = (allItems, labelItems = []) =>
  labelItems.reduce((allFullItems, currentItem) => {
    const { item_id: currentItemId, qty } = currentItem;

    const itemData = allItems.find(({ item_id: itemId }) => currentItemId === itemId);

    if (!itemData) return allFullItems;

    return [...allFullItems, { ...itemData, qty }];
  }, []);

export const processLabels = (labels) => (dispatch, getState) => {
  const { retailerSettings: { name: retailerName } = {}, orderItems: { allItems = [] } = {} } =
    getState();

  const mappedLabels = labels.map((label) => {
    const { returned_items: labelItems = [] } = label;

    return {
      ...label,
      url: generateLabelUrl({ retailerName, label }),
      return_items: labelItemsWithQuantities(allItems, labelItems),
    };
  });

  const labelItemCount = mappedLabels.reduce(
    (currentItemCount, { qty = 0 }) => currentItemCount + qty,
    0,
  );

  dispatch({
    type: RECEIVE_LABELS,
    data: {
      labelItemCount,
      labels: mappedLabels,
    },
  });
};

export const processOrderItems =
  (allItems = []) =>
  (dispatch, getState) => {
    const { page: { productType, exchangesEnabled } = {} } = getState();

    const productToken = productType.substr(0, productType.length - 1);
    const eligibilitiesToCheck = [productToken, ...(exchangesEnabled ? ['exchange'] : [])];

    const ineligibleItems = allItems.filter((item) => {
      const { item_eligibilities: itemEligibilities, return_status: itemStatus } = item;

      const itemIsEligible = eligibilitiesToCheck.every((product) =>
        !isEmpty(itemEligibilities)
          ? !itemEligibilities[product].is_eligible
          : !item[`${product}_eligibility`],
      );

      return itemIsEligible && itemStatus !== 'label generated';
    });

    const ineligibleItemIds = ineligibleItems.map(({ item_id: itemId }) => itemId);

    const eligibleItems = allItems
      .filter(({ remaining_qty: remainingQuantity }) => remainingQuantity > 0)
      .filter(({ item_id: itemId }) => ineligibleItemIds.indexOf(itemId) === -1);

    dispatch({
      type: PROCESS_ORDER_ITEMS,
      data: {
        allItems,
        eligibleItems,
        ineligibleItems,
      },
    });
  };
